export function ValidateEmail(mail) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*([.]\w{2,})+$/.test(mail)) {
    return true;
  }
  return false;
}
